var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.label,"solo":"","hide-details":"","clearable":""},on:{"change":_vm.notifyChange}},[_c('v-icon',{attrs:{"slot":"append"},slot:"append"},[_vm._v(" mdi-magnify ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }